import type { ArticlesCollectionItem } from "@nuxt/content";
import {toRef} from "#imports";

export const useArticlesPage = async (params: MaybeRef<Partial<Pick<ArticlesCollectionItem, 'title'|'date'|'tags'> & { orderBy: { order: keyof ArticlesCollectionItem, by: 'DESC'|'ASC' } }>> = { orderBy: { order: 'date', by: 'DESC' } }) => {

    const orderBy = computed<{ order: keyof ArticlesCollectionItem, by: 'DESC' | 'ASC'}>(() => {
        const { orderBy, ...filter } = unref(params)
        console.log("排序参数...", orderBy)
        return orderBy? orderBy: { order: 'date', by: 'DESC' }
    })

    const filterObject = computed(() => {
        const { orderBy, ...filter } = unref(params)
        console.log("过滤参数...", filter)
        return filter? filter: filter
    })

    const { data: articleList, refresh } = await useAsyncData('useArticlesPage', () => {
        const filterEntries = Object.entries(filterObject.value)
        const query = queryCollection('articles')
        for (const filter of filterEntries) {
            console.log('添加过滤参数', filter[0], `%${unref(filter[1]).toString()}%`)
            query.where(filter[0], 'LIKE', `%${unref(filter[1]).toString() === '全部'? '': unref(filter[1]).toString()}%`)

        }
        return query.order(orderBy.value.order, orderBy.value.by).all()
    })

    let firstInited: ArticlesCollectionItem[] | null = null
    const pageData = reactive<{
        pageList: MaybeRef<ArticlesCollectionItem[]>,
        hotList: MaybeRef<ArticlesCollectionItem[]>,
        tagsList: MaybeRef<string[]>,
        lasterList: MaybeRef<ArticlesCollectionItem[]>,
        dateList: MaybeRef<Record<string, number|string>[]>
    }>({
        pageList: computed(() => {
            if (!firstInited && articleList.value?.length) {
                firstInited = JSON.parse(JSON.stringify(articleList.value))
                return firstInited!
            }else if (firstInited){
                return firstInited!
            }
            return []
        }),
        hotList: computed(() => firstInited?.filter(item => item.hot) || []),
        tagsList: computed(() => {
            const tags = firstInited?.map(item => {
                return item.tags
            })?.join('、')?.split('、')?.filter(tag => !!tag) || []
            return Array.from(new Set(tags))
        }),
        lasterList: computed(() => articleList.value?.slice(0, 6) || []),
        dateList: computed(() => {
            const dateGroup: Record<string, ArticlesCollectionItem[]> = {}
            firstInited?.map(item => {
                if (dateGroup[item.date] && item.date) {
                    dateGroup[item.date]?.push(item)
                } else {
                    dateGroup[item.date] = [item]
                }
            })
            const dateArray = Object.keys(dateGroup)?.sort((a, b) => (Number(a) - Number(b))) || []
            return dateArray?.map(item => {
                return {
                    date: item,
                    count: dateGroup[item]?.length || 0
                }
            })
        })
    })

    return { ...toRefs(pageData), articleList, refresh }
}